import React, { createContext } from "react";


export const ProductSelected = createContext({});